module.exports = __webpack_public_path__ + "img/19-800x800.c17595cb.jpg";